import NivelServico from "@/components/utils/dataTable/sysDataTableDepartamentos/Componentes/NivelServico";
import InfoProdutoNoCarrinho from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/InfoProdutoNoCarrinho";
import CalculaCoberturaEstoqueFutura from "@/components/compra/CalculaCoberturaEstoqueFutura";
import SugestaoDeCompra from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/SugestaoDeCompra";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import ConsiderarEstoqueGrupo from "../ConsiderarEstoqueGrupo.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import SugestaoDistribuicao from "./SugestaoDistribuicao.vue";
import ProdutoSilenciado from "./ProdutoSilenciado.vue";
import DetalhamentoCarrinhosProduto from "./DetalhamentoCarrinhosProduto";
import PrecoCusto from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/PrecoCusto.vue";
import ConsolidarCompraParaUmaFilial from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/ConsolidarCompraParaUmaFilial.vue";

export const componentes = {
  InfoProdutoNoCarrinho,
  SugestaoDeCompra,
  CalculaCoberturaEstoqueFutura,
  NivelServico,
  ConverterEmbalagem,
  ConsiderarEstoqueGrupo,
  DetalhesProduto,
  SugestaoDistribuicao,
  ProdutoSilenciado,
  DetalhamentoCarrinhosProduto,
  PrecoCusto,
  ConsolidarCompraParaUmaFilial,
}
